module.exports = __webpack_public_path__ + "static/media/MSME-Declaration-Non-MSME.44f8455c.docx";